/**
 * Collapsible Tabs — Dawn 15
 * One-at-a-time accordion with smooth height animation.
 */
(function () {
  function initSection(section) {
    const triggers = Array.from(section.querySelectorAll('.collapsible-tab__trigger'));

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        // Close all open tabs in this section
        triggers.forEach((t) => {
          if (t.getAttribute('aria-expanded') === 'true') {
            closeTab(t);
          }
        });

        // If it was closed, open it
        if (!isOpen) {
          openTab(trigger, () => scrollToTab(trigger));
        }
      });
    });
  }

  function scrollToTab(trigger) {
    const tab = trigger.closest('.collapsible-tab');

    // Read whatever sticky offset is set in CSS (e.g. top: 85px for a sticky
    // header) so the scroll target always matches the sticky position,
    // even if that value changes later.
    const stickyTop = parseInt(window.getComputedStyle(trigger).top, 10) || 0;

    const targetY = window.scrollY + tab.getBoundingClientRect().top - stickyTop;

    window.scrollTo({
      top: Math.max(targetY, 0),
      behavior: 'smooth'
    });
  }

  function openTab(trigger, onOpened) {
    const tab   = trigger.closest('.collapsible-tab');
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));

    trigger.setAttribute('aria-expanded', 'true');
    tab.classList.add('collapsible-tab--open');

    panel.removeAttribute('hidden');
    panel.style.height   = '0px';
    panel.style.overflow = 'hidden';

    // Double rAF to ensure hidden→visible transition fires
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        panel.style.height = panel.scrollHeight + 'px';
      });
    });

    panel.addEventListener('transitionend', function done() {
      panel.style.height   = '';
      panel.style.overflow = '';
      panel.removeEventListener('transitionend', done);

      // Layout has now settled (this tab finished expanding, and any
      // other tab's collapse animation runs on the same duration so it's
      // done too) — safe to measure and scroll without overshooting.
      if (onOpened) onOpened();
    });
  }

  function closeTab(trigger) {
    const tab   = trigger.closest('.collapsible-tab');
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));

    trigger.setAttribute('aria-expanded', 'false');
    tab.classList.remove('collapsible-tab--open');

    panel.style.height   = panel.scrollHeight + 'px';
    panel.style.overflow = 'hidden';

    // Force reflow before collapsing
    panel.getBoundingClientRect();
    panel.style.height = '0px';

    panel.addEventListener('transitionend', function done() {
      panel.setAttribute('hidden', '');
      panel.style.height   = '';
      panel.style.overflow = '';
      panel.removeEventListener('transitionend', done);
    });
  }

  document.querySelectorAll('.collapsible-tabs').forEach(initSection);
})();